<body>
  <div class="banner">
    <div class="banner-image"><img src="assets/images/engagement-banner-image.svg"></div>
    <div class="banner-content">The request analytics in the Engagement tab are not real-time. Metrics, including downloadable data, are computed in batches and shown for requests received 48 hours earlier. These metrics are dynamic and will continue to update constantly until the conversation link expires.</div>
</div>
  
  <div class="ltms-tabs engagement-tabs-row">
  <span class="ltms-tab" *ngIf="tabVisiblity.lite" (click)="onClickingNavigation('lite')" [ngClass]="{'ltms-active-tab': activeTab === 'lite' || !activeTab}">Engagement</span>
  <span class="ltms-tab" *ngIf="tabVisiblity.pro" (click)="onClickingNavigation('pro')" [ngClass]="{'ltms-active-tab': activeTab === 'pro'}">Engagement Pro</span>
  <span class="ltms-tab" *ngIf="tabVisiblity.details" (click)="onClickingNavigation('details')" [ngClass]="{'ltms-active-tab': activeTab === 'details'}">Details</span>
  <!-- <span class="ltms-tab" *ngIf="tabVisiblity.lite || tabVisiblity.pro" (click)="onClickingNavigation('summary')" [ngClass]="{'ltms-active-tab': activeTab === 'summary'}">Engagement Summary</span>   -->
  <div class="engagement-deviation-toggle" *ngIf="(activeTab === 'lite' || !activeTab || activeTab === 'pro' || activeTab === 'details' || activeTab === 'summary') && showDeviationToggle">
    <label class="deviation-round-checkbox" [ngClass]="{'active': isDeviationEnabled}">
      <input type="checkbox" [checked]="isDeviationEnabled" (change)="onDeviationToggle($event)" />
      <img *ngIf="!isDeviationEnabled" src="assets/images/checkbox-blank-circle-outline.svg" alt="" />
      <img *ngIf="isDeviationEnabled" src="assets/images/checkBox-circle-fill-svg.svg" alt="" />
      <span class="deviation-switch-label">Show Deviation</span>
    </label>
  </div>
</div>
  <div *ngIf="queryParams$ | async as params">
  <div *ngIf="(activeTab === 'lite' || !activeTab) && tabVisiblity.lite">
      <app-engagement-lite [isDeviationEnabled]="isDeviationEnabled"></app-engagement-lite>
  </div>
  <div *ngIf="activeTab === 'pro' && tabVisiblity.pro">
      <app-engagement-pro [isDeviationEnabled]="isDeviationEnabled"></app-engagement-pro>
  </div>
  <div *ngIf="activeTab === 'details' && tabVisiblity.details">
      <app-engagement-details [isDeviationEnabled]="isDeviationEnabled"></app-engagement-details>
  </div>
  <div *ngIf="activeTab === 'summary' && (tabVisiblity.lite || tabVisiblity.pro)">
    <app-engagement-summary [isDeviationEnabled]="isDeviationEnabled"></app-engagement-summary>
  </div>
  </div>
  </body>